import { Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CreateJobComponent } from './pages/create-job/create-job.component';
import { MyJobsComponent } from './pages/my-jobs/my-jobs.component';
import { JobComponent } from './pages/job/job.component';
import { DashboardContentComponent } from './pages/dashboard-content/dashboard-content.component';
import { PlansComponent } from './pages/plans/plans.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { AuthGuard } from './helpers/auth.gard';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { PaymentSuccessComponent } from './pages/payment-success/payment-success.component';
import { PaymentErrorComponent } from './pages/payment-error/payment-error.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { AboutComponent } from './pages/about/about.component';
import { VideoEditingComponent } from './pages/video-editing/video-editing.component';
import { JobDetailComponent } from './pages/job-detail/job-detail.component';

export const routes: Routes = [
    {
        path: 'dashboard', component: DashboardComponent, title: 'Dashboard', canActivate: [AuthGuard], children: [
            { path: '', component: DashboardContentComponent, title: 'Dashboard' },
            { path: 'job/:id', component: JobComponent, children:[
                {path: '', component: JobDetailComponent, title: 'Job Details'},
                {path: ':taskId/video-editing', component: VideoEditingComponent, title: 'Video Editing'},
            ] },
            { path: 'my-jobs', component: MyJobsComponent, title: "My Videos" },
            { path: 'create-job', component: CreateJobComponent, title: 'New Translation' },
            { path: 'notifs', component: NotificationsComponent, title: 'Notifications' },
            { path: 'plans', component: PlansComponent, title: 'Plans' },
            { path: 'payment-success', component: PaymentSuccessComponent, title: 'payment success !' },
            { path: 'payment-error', component: PaymentErrorComponent, title: 'payment error' },
            { path: 'settings', component: SettingsComponent },
            { path: 'about', component: AboutComponent, title: 'About' },
            { path: 'profile', component:ProfileComponent, title:'profile' }
        ]
    },
    { path: 'terms', component: TermsComponent, title: 'Terms' },
    { path: 'privacy', component: PrivacyPolicyComponent, title: 'Privacy policy' },
    { path: '', component: LandingPageComponent, title: 'SVET' },
    { path: '**', redirectTo: '' }
];
